export default {
	'1': '100%',
	'1/2': '50%',
	'1/3': '33.33%',
	'2/3': '66.66%',
	'1/4': '25%',
	'3/4': '75%',

	'1/5': '20%',
	'2/5': '40%',
	'3/5': '60%',
	'4/5': '80%',

	'1/6': '16.66%',
	'5/6': '83.33%',
};



// WEBPACK FOOTER //
// ./components/Grid/widths.js